// URL工具类
class Util {
	static getUrlParameter(name) {
		name = name.replace(/\[/, "\\[").replace(/\]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		var results = regex.exec(window.location.search);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}
	static sleep(ms = 0) {
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve(true);
			}, ms);
		});
	}
}

window.Util = Util;


